import { getNetworkDetail } from 'services';

export default {
  namespace: 'airportMotion',
  state: {
    loungeList: [],
    allData: {},
  },
  effects: {
    *queryNetworkDetail({ payload }, { call, put }) {
      const response = yield call(getNetworkDetail, payload);
      if (response.data.state === '11') {
        yield put({
          type: 'setData',
          payload: {
            loungeList: response.data.data.list,
            allData: response.data.data,
          },
        });
        payload.callback && payload.callback();
      }
    },
  },
  reducers: {
    setData(state, { payload }) {
      return {
        ...state,
        ...payload,
      };
    },
  },
};
